export function sendReferrerDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: sendReferrerDirectiveCtrl,
	};
}

export class sendReferrerDirectiveCtrl {
	constructor($element, $attrs) {
		'ngInject';
		const referrer = () => {
			setTimeout(() => {
				if (
					$attrs.shSendReferrer === true ||
					$attrs.shSendReferrer === 'true' ||
					parseInt($attrs.shSendReferrer, 10) === 1
				) {
					$element.attr('referrerpolicy', 'unsafe-url');
					$element.attr('rel', 'noopener');
				} else {
					$element.removeAttr('referrerpolicy');
					$element.attr('rel', 'noreferrer noopener');
				}
			}, 0);
		};
		$attrs.$observe('shSendReferrer', referrer);
	}
}
